import Settings from '../Settings'
import Utils from '../Utils'

const Burger = {
    init() {
        if (this.cacheDom()) {
            this.mq = window.matchMedia(Settings.mobileMq)
            this.onKeydown = this.onKeydown.bind(this)
            this.syncInert()
            this.bindEvents()
        }
    },

    cacheDom() {
        this.burger = document.querySelector('[data-burger]')
        this.nav = document.querySelector('[data-nav]')
        return this.burger && this.nav
    },

    bindEvents() {
        this.burger.addEventListener('click', this.toggle.bind(this))
        this.mq.addEventListener('change', this.onBreakpointChange.bind(this))
    },

    isOpen() {
        return this.burger.getAttribute('aria-expanded') === 'true'
    },

    syncInert() {
        // Desktop: never inert. Mobile: inert only while closed.
        this.nav.toggleAttribute('inert', this.mq.matches && !this.isOpen())
    },

    getTrapFocusables() {
        return [this.burger, ...Utils.getFocusables(this.nav)]
    },

    open() {
        this.burger.setAttribute('aria-expanded', 'true')
        document.body.classList.add('burger-open')
        this.syncInert()
        document.addEventListener('keydown', this.onKeydown)

        const firstInNav = Utils.getFocusables(this.nav)[0]
        ;(firstInNav || this.burger).focus()
    },

    close({ restoreFocus = true } = {}) {
        this.burger.setAttribute('aria-expanded', 'false')
        document.body.classList.add('burger-closing')
        document.body.classList.remove('burger-open')
        this.syncInert()
        document.removeEventListener('keydown', this.onKeydown)

        setTimeout(() => {
            document.body.classList.remove('burger-closing')
        }, 300)

        if (restoreFocus) {
            this.burger.focus()
        }
    },

    toggle() {
        if (this.isOpen()) {
            this.close()
        } else {
            this.open()
        }
    },

    onBreakpointChange() {
        if (!this.mq.matches && this.isOpen()) {
            this.close({ restoreFocus: false })
            return
        }

        this.syncInert()
    },

    onKeydown(e) {
        if (!this.isOpen()) return

        if (e.key === 'Escape') {
            e.preventDefault()
            this.close()
            return
        }

        if (e.key !== 'Tab') return

        const focusables = this.getTrapFocusables()
        if (!focusables.length) return

        const first = focusables[0]
        const last = focusables[focusables.length - 1]

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault()
            last.focus()
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault()
            first.focus()
        }
    },
}

export default Burger
